import React from 'react';
import styles from './tv-guide.module.scss';
import clsx from 'clsx';
import { useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import useVodPlayer from '@smart-tv/components/player/vod-wrapper/_hooks/use-vod-player';
import { StreamOptions } from '@smart-tv/components/player/vod-wrapper/_contexts/stream-player-context';
import { StreamType } from '@smart-tv/typings/content';
import { TvGuideChannel } from '@smart-tv/pages/tv-guide/types';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  channel: TvGuideChannel;
}

const TvGuideEmpty: React.FC<Props> = (props: Props) => {
  const { channel, style } = props;
  const { sid } = channel;
  const { handleOpen } = useVodPlayer();

  const onEnterPress = React.useCallback(() => {
    const streamOptions: StreamOptions = {
      streamType: StreamType.LiveStream,
      streamParams: { sid }
    };
    handleOpen(streamOptions);
  }, [handleOpen, sid]);

  const { ref, focused } = useFocusable({
    onEnterPress,
    focusKey: `tv-guide-empty-channel-${sid}`
  });

  return (
    <div
      className={clsx(styles['tv-guide-programs__row-empty'], {
        [styles['tv-guide-programs__row-empty--focused']]: focused
      })}
      ref={ref}
      style={style}
    />
  );
};

export default React.memo(TvGuideEmpty);
